import React from 'react';
import { Calculator } from 'dx-sdk/build/components';
import BudgetCalculatorStyles from './BudgetCalculator.styled';
import {
  initialState,
  useCalculator,
} from 'dx-sdk/build/components/Calculator/utilities';
const initialStateUpdates = {
  ...initialState,
  loanTerm: 25,
  annualInsuranceMax: 4000,
};

export const BudgetCalculator = () => {
  const calcInstance = useCalculator({ initState: initialStateUpdates });
  return (
    <BudgetCalculatorStyles id="calculatorSection">
      <div className="container">
        <div className="headline-wrap">
          <h3>
            Use the calculator to see how different factors can impact your
            monthly payment.
          </h3>
        </div>
        <Calculator className="budgetCalc" useCalculatorInstance={calcInstance}>
          {({ calculator }) => (
            <Calculator.Disclaimer calculator={calculator}>
              <p className="disclaimer">
                <u>Please note:</u> The results from the calculator are only
                estimates. There are additional costs to buying a home that may
                not be reflected in this calculator. Always compare loan offers
                you may receive before making your decision.
              </p>
            </Calculator.Disclaimer>
          )}
        </Calculator>
      </div>
    </BudgetCalculatorStyles>
  );
};

export default BudgetCalculator;
